import { render, staticRenderFns } from "./BundleItemInput.vue?vue&type=template&id=4d3defd2&scoped=true&"
import script from "./BundleItemInput.vue?vue&type=script&lang=js&"
export * from "./BundleItemInput.vue?vue&type=script&lang=js&"
import style0 from "./BundleItemInput.vue?vue&type=style&index=0&id=4d3defd2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3defd2",
  null
  
)

export default component.exports